<template>
  <div id="app">
    <div class="body_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="side_container">
                  <div id="digest_table">
                    <h3 v-html="infoObj.Title">
                      <a href="" type="button" class="btn-secondary" data-toggle="tooltip" data-placement="top" title="" data-original-title="PDF下载" v-if="infoObj.PDFFile_Size>0"><img src="../assets/images/pdf.jpg" width="20"></a>
                    </h3>
                    <div class="copy_title">
                      <p class="text" style="background:transparent;border-style:none;width: 100%;height:auto;overflow-y:hidden;resize: none;outline: none"
                      ref="texta" v-html="infoObj.InCite">
                       
                       </p>
                       
                      <span>
                      <el-button @click="copy" type="primary" size="mini">点击复制</el-button>
                    </span>
                      </div>
                    <p class="ten detail_yjq">
                      <span>《{{Itmtitle}}》</span>
                      <span>[ISSN:{{ISSN}}/CN:{{CN}}]</span>
                      <span class="advance_date" v-if="infoObj.Publish_Date">[预出版日期：{{(infoObj.Publish_Date).substring(0,infoObj.Publish_Date.lastIndexOf("T"))}}]</span>
                    </p>
                    <table class="table ten" style="width: 100%">
                      <tbody>
                      <tr v-if="isEnzhaiy">
                        <th scope="row" align="left">Title:</th>
                        <td v-html="infoObj.TitleE"></td>
                      </tr>
                      <tr>
                        <th scope="row" align="left">作者:</th>
                        <td>
                         <p v-show="this.a != 1"><a href="javascript:;" class="span" @click="toSearch" v-for="(a,i) in text" :key='i'><span  v-html="a"></span><span v-if="i != text.length-1"> ,</span></a></p>
                          <p v-show="this.a == 1" v-html="infoObj.AuthorsList">
                          </p>
                          <p v-html="infoObj.Unit"></p>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" align="left">Author(s):</th>
                        <td>
                          <p  v-if="this.a != 1"><a href="javascript:;"  @click="toSearch" class="span" v-for="(a,i) in actor" :key='i'><span  v-html="a"></span><span v-if="i != actor.length-1"> ,</span></a></p>
                          <p v-if="this.a == 1" v-html="infoObj.AuthorsListE"></p>
                          <p v-html="infoObj.Unit_EngLish"></p>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" align="left">关键词:</th>
                        <td>
                           <p  v-if="this.a != 1"><a href="javascript:;" @click="toSearch" class="span" v-for="(a,i) in key" :key='i'><span  v-html="a"></span><span v-if="i != key.length-1"> ;</span></a></p>
                           <p v-if="this.a == 1" v-html="infoObj.Keyword_Chinese"></p>
                        </td>
                      </tr>
                      <tr v-if="isEnzhaiy">
                        <th scope="row" align="left">Keywords:</th>
                        <td>
                          <p  v-if="this.a != 1"><a href="javascript:;" @click="toSearch" class="span" v-for="(a,i) in keyEng"  :key='i'><span  v-html="a"></span><span v-if="i != keyEng.length-1"> ;</span></a></p>
                         <p v-if="this.a == 1" v-html="infoObj.Keywords_English"></p>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" align="left">分类号:</th>
                        <td v-html="infoObj.ZTFLH"></td>
                      </tr>
                      <tr>
                        <th scope="row" align="left">DOI:</th>
                        <td v-html="infoObj.DOI"></td>
                      </tr>
                      <tr>
                        <th scope="row" align="left">摘要:</th>
                        <td v-html="infoObj.Abstract_Chinese"></td>
                      </tr>
                      <tr v-if="isEnzhaiy">
                        <th scope="row" align="left" class="text-top">Abstract:</th>
                        <td v-html="infoObj.Abstract_English"></td>
                      </tr>
                      <tr>
                        <th scope="row" align="left" class="text-top">参考文献<br />/References:</th>
                        <td v-html="infoObj.Reference"></td>
                      </tr>
                      <tr>
                        <th scope="row" align="left">备注/Memo:</th>
                        <td v-html="infoObj.Memory"></td>
                      </tr>
                      </tbody>
                    </table>

                  </div>
                  <Comment :CommentList="CommentList" :comm='comm' v-if="isComment"></Comment>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import Comment from '../components/comment'
  export default {
    data() {
      return {
        form:[],
        List: [],
        infoObj: [],
        comm: 0,
        CommentList: [],
        Token: '',
        commentText: '', // 评论内容
        TotalComments: 1000, // 评论总条数
        checked: false, // 是否匿名发表
        cc: '',
        NickyName: "",
        aa: '',
        previos: '',
        naxt: '',
        idnode: -1,
        issue:'',
        text: [],
        idnext: -1,
        bb: '',
        Title: '',
        newArr: [],
        actor: [],
        key: [],
        Comments: '',
        keyEng: [],
        id: '',
        title: '',
        ida: '',
        indoe: "",
        inext: "",
        kind: 2,
        a:'',
        name:'',
        CanReview:false,
        isComment:false,
        isEnzhaiy:false,
        ISSN:"",
        CN:"",
        Itmtitle:'',
        path:''
      }
    },
    components:{
      Comment
    },
    mounted(){
      var id = this.$route.query.ArticleID;
      this.id=this.$route.query.ArticleID;
      
      this._getPLLB(id)
      if(sessionStorage.getItem("SetItem")){
        let SetItem=JSON.parse(sessionStorage.getItem("SetItem"))
      SetItem.map((item)=>{
          if(item.SetItemID==230){
              item.Item_Value=="是"?this.isComment=true:this.isComment=false
          }
          if(item.SetItemID==6055){
              item.Item_Value=="是"?this.isEnzhaiy=true:this.isEnzhaiy=false
          }
          if(item.SetItemID==5000){
             this.ISSN=item.Item_Value
          }
          if(item.SetItemID==5010){
             this.CN=item.Item_Value
          }
          if(item.SetItemID==1000){
             this.Itmtitle=item.Item_Value
          }
          if(item.SetItemID==6018){
             if(item.Item_Value=="是"){
              //  if(this.$route.query.scriptID){
                   this.path='_GetScriptPrePrintDetailed'
              //   }else{
              //     this.path='_getLBXQ'
              //   }
             }else{
              //  if(this.$route.query.scriptID){
              //     this.path='_GetScriptPrePrintDetailed'
              //   }else{
                   this.path='_getLBXQ'
              //   }
             }
             this.getLBXQ()
          }
      })
      }else{
        let params = [1000,1001,4530,6018,6019,230,6055,5000,5010,99,96,11,2960,4553]
        this.$store.dispatch("_getSet",params)
        .then(res => {
          this.SetItem=res.data.Data
          sessionStorage.setItem("SetItem",JSON.stringify(res.data.Data))
          this.SetItem.map((item)=>{
          if(item.SetItemID==230){
              item.Item_Value=="是"?this.isComment=true:this.isComment=false
          }
          if(item.SetItemID==6055){
              item.Item_Value=="是"?this.isEnzhaiy=true:this.isEnzhaiy=false
          }
          if(item.SetItemID==5000){
             this.ISSN=item.Item_Value
          }
          if(item.SetItemID==5010){
             this.CN=item.Item_Value
          }
          if(item.SetItemID==1000){
             this.Itmtitle=item.Item_Value
          }
          if(item.SetItemID==6018){
             if(item.Item_Value=="是"){
               if(this.$route.query.scriptID){
                  this.path='_GetScriptPrePrintDetailed'
                }else{
                  this.path='_getLBXQ'
                }
             }else{
               if(this.$route.query.scriptID){
                  this.path='_GetScriptPrePrintDetailed'
                }else{
                  this.path='_getLBXQ'
                }
             }
             this.getLBXQ()
          }
      })
        }).catch(err => {
          console.log(err)
        })	
      }
      
      
    },
    methods: {
      onSubmit() {
      },
       _getPLLB(id){
        var id = id
        let params = {
          Type: 2,
          ID: id,
          PageSize: 3
        }
        var a = sessionStorage.getItem('aa')
        if (a == 1) {
          params.Type = 4
        } else {
          params.Type = 2
        }
         this.$store.dispatch("_getPLLB",params)
        .then(res => {
          if (res.data.IsSuccess) {
            this.CommentList = res.data.Data
            this.comm = res.data.ItemCount
          }
        }).catch(err => {
          console.log("err", err)
        })
      },
      getLBXQ(){
        var id = this.id
        var time =new Date().getTime() 
        let params = {
          Id:id,
          sec:time
        }
        this.$store.dispatch(this.path,params).then(res=>{
          this.infoObj = res.data.Data
          console.log(this.infoObj,1221)
          var a = this.infoObj.IssueID
          sessionStorage.setItem('a',a)
          if(res.data.Data.AuthorsList){
            if(res.data.Data.AuthorsList.indexOf(',') != -1){
            this.text = res.data.Data.AuthorsList.split(",")
          }else if(res.data.Data.AuthorsList.indexOf(';') != -1){
            this.text = res.data.Data.AuthorsList.split(";")
          }
          else{
            this.text = res.data.Data.AuthorsList.split("，")
          }
          }
          
          if(res.data.Data.AuthorsListE){
            if(res.data.Data.AuthorsListE.indexOf(',') != -1){
            this.actor = res.data.Data.AuthorsListE.split(",")
          }else if(res.data.Data.AuthorsListE.indexOf(';') != -1){
            this.actor = res.data.Data.AuthorsListE.split(";")
          }
          else{
            this.actor = res.data.Data.AuthorsListE.split("，")
          }
          }
          if(res.data.Data.Keyword_Chinese){
            if(res.data.Data.Keyword_Chinese.indexOf(',') != -1){
            this.key = res.data.Data.Keyword_Chinese.split(",")
          }else if(res.data.Data.Keyword_Chinese.indexOf('、') != -1){
            this.key = res.data.Data.Keyword_Chinese.split("、")
          }else if(res.data.Data.Keyword_Chinese.indexOf(';') != -1){
            this.key = res.data.Data.Keyword_Chinese.split(";")
          }else if(res.data.Data.Keyword_Chinese.indexOf('；') != -1){
            this.key = res.data.Data.Keyword_Chinese.split("；")
          }
          else{
            this.key = res.data.Data.Keyword_Chinese.split("，")
          }
          }
          if(res.data.Data.Keywords_English){
            if(res.data.Data.Keywords_English.indexOf(',') != -1){
            this.keyEng = res.data.Data.Keywords_English.split(",")
          }else if(res.data.Data.Keywords_English.indexOf('、') != -1){
            this.keyEng = res.data.Data.Keywords_English.split("、")
          }else if(res.data.Data.Keywords_English.indexOf(';') != -1){
            this.keyEng = res.data.Data.Keywords_English.split(";")
          }else if(res.data.Data.Keywords_English.indexOf('；') != -1){
            this.keyEng = res.data.Data.Keywords_English.split("；")
          }
          else{
            this.keyEng = res.data.Data.Keywords_English.split("，")
          }
          }
          this.name = res.data.Data.AuthorsHTML
        }).catch(err=>{
          console.log(err)
        })
      },
  copy(){
	  var text = this.$refs.texta
        var Url2 = this.$refs.texta.innerText
        var oInput = document.createElement("input");
        oInput.value = Url2;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        oInput.className = "oInput";
        oInput.style.display = "none";
        alert("复制成功");
    },
    toSearch(e) {
        var put = e.target.innerText
        if(put.indexOf('1') != -1){
          var a = put.split('1')[0]
          var b = a
          console.log(a)
        }else if(put.indexOf('2') != -1){
          var a = put.split('2')[0]
          console.log(a)
          var b = a
        }else if(put.indexOf('3') != -1){
          var a = put.split('3')[0]
          console.log(a)

        }else{
          var a = put
        }
        var b = a
        console.log(b)
        var name = e.target.className
        localStorage.setItem('value', b)
        if(b!= ''){
          e.preventDefault()
            let routeUrl = this.$router.resolve({
              path: '/#/QuickSearch'
            });
            window.open(routeUrl.href, '_blank');
        }

      },
    }
  }
</script>

<style scoped>
.text-top{
  vertical-align: text-top;
  padding-top: 0;
}
</style>
